import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/blocks/announcement/rotator/rotator-bar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/blocks/collection/bundle/add-bundle-button.tsx");
;
import(/* webpackMode: "eager" */ "/repo/apps/storefront/src/modules/blocks/collection/featured/carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/blocks/collection/tabs/tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CountdownClock","CountdownGate"] */ "/repo/apps/storefront/src/modules/blocks/countdown/timer/clock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/blocks/listing/price-table/order-cell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/blocks/media/stories/viewer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/blocks/promo/code-banner/copy-code.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/blocks/slideshow/banners/carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/blocks/testimonials/cards/carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/blocks/video/embed/player.tsx");
;
import(/* webpackMode: "eager" */ "/repo/apps/storefront/src/modules/home/components/add-to-bag-button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/home/variants/hero-ga-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/home/variants/hero-gb-strips.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/home/variants/olavka-loop-track.tsx");
;
import(/* webpackMode: "eager" */ "/repo/apps/storefront/src/modules/layout/components/account-link/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/layout/components/cart-trigger/index.tsx");
;
import(/* webpackMode: "eager" */ "/repo/apps/storefront/src/modules/layout/components/mode-toggle/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/layout/components/olavka-category-rail/header-search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/layout/components/olavka-category-rail/rail.tsx");
;
import(/* webpackMode: "eager" */ "/repo/apps/storefront/src/modules/layout/components/region-select/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/layout/components/scroll-flag/index.tsx");
;
import(/* webpackMode: "eager" */ "/repo/apps/storefront/src/modules/layout/components/search/index.tsx");
;
import(/* webpackMode: "eager" */ "/repo/apps/storefront/src/modules/layout/components/side-menu/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/products/components/product-media/hover-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/products/components/wishlist-button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/store/components/infinite-products/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/apps/storefront/src/modules/store/components/view-controls/index.tsx");
;
import(/* webpackMode: "eager" */ "/repo/apps/storefront/src/modules/studio/components/brand-unlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/node_modules/.pnpm/lucide-react@1.55.0_@types+react@19.0.5_react@19.0.5/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/node_modules/.pnpm/next-intl@4.12.0_@swc+helpers@0.5.17_next@15.5.21_@babel+core@7.28.5_@opentelemetry+api_99c411e3f8e25dde4498464371af6354/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/repo/node_modules/.pnpm/next-intl@4.12.0_@swc+helpers@0.5.17_next@15.5.21_@babel+core@7.28.5_@opentelemetry+api_99c411e3f8e25dde4498464371af6354/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/repo/node_modules/.pnpm/next@15.5.21_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.63.0_@types_71015db17785f2d0f30558ab4e723d87/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/repo/node_modules/.pnpm/next@15.5.21_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.63.0_@types_71015db17785f2d0f30558ab4e723d87/node_modules/next/dist/client/image-component.js");
